import { BookkeepingItem } from '@features/reconciliation/types/bookkeepingItem'
import { BankLineMatch } from '@modules-deprecated/bankReconciliation/types'

import { SandboxState } from '../sandboxModeContext'

export type SandboxAction =
  | { type: 'MATCH_BANK_LINE'; bankLineId: string; match: BankLineMatch; bookkeepingItems: BookkeepingItem[] }
  | { type: 'UNMATCH_BANK_LINE'; matchId: string }
  | { type: 'DISMISS_SUGGESTION'; bankLineId: string }

export const sandboxReducer = (state: SandboxState, action: SandboxAction): SandboxState => {
  switch (action.type) {
    case 'MATCH_BANK_LINE': {
      const bankLines = state.bankLines.map((line) =>
        line.id === action.bankLineId ? { ...line, matchId: action.match.id, match: action.match } : line,
      )

      return {
        ...state,
        bankLines,
        matchedItemsByMatchId: { ...state.matchedItemsByMatchId, [action.match.id]: action.bookkeepingItems },
      }
    }

    case 'UNMATCH_BANK_LINE': {
      const bankLines = state.bankLines.map((line) =>
        line.match?.id === action.matchId && line.match
          ? { ...line, match: { ...line.match, isApproved: false } }
          : line,
      )

      return { ...state, bankLines }
    }

    case 'DISMISS_SUGGESTION': {
      const suggestions = state.suggestions.filter(
        (suggestion) => !suggestion.transactions.some((transaction) => transaction.id === action.bankLineId),
      )

      return { ...state, suggestions }
    }

    default:
      return state
  }
}
